// src/store/useAuthStore.ts
import { create } from 'zustand';
import { User } from '../types';
import { mockUsers } from '../data/mockData';

interface AuthState {
  currentUser: User | null;
  login: (email: string, password: string) => boolean;
  logout: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  currentUser: null,
  
  login: (email: string, password: string) => {
    // Simulación de login - busca el usuario por email
    const user = mockUsers.find(u => u.email === email);
    
    if (user) {
      set({ currentUser: user });
      return true;
    }
    
    return false;
  },
  
  logout: () => {
    set({ currentUser: null });
  },
}));
